export const QUANTITY_DECIMAL_PLACES = 3;


